import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ContactUs = () => {
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-6">
      <div className="max-w-md mx-auto bg-white rounded-xl shadow-md p-6">
        
        {/* Title */}
        <h2 className="text-xl font-semibold text-center mb-6">
          Contact Details
        </h2>

        {/* Mobile */}
        <div className="flex items-start gap-3 mb-4">
          <span className="font-semibold text-gray-700 w-28">
            Mobile:
          </span>
          <a
            href="tel:+919481699771"
            className="text-blue-600 hover:underline"
          >
            +91 94816 99771
          </a>
        </div>

        {/* Email */}
        <div className="flex items-start gap-3 mb-4">
          <span className="font-semibold text-gray-700 w-28">
            Email:
          </span>
          <a
            href="mailto:support@apmsmarthub.com"
            className="text-blue-600 hover:underline break-all"
          >
            support@apmsmarthub.com
          </a>
        </div>

        {/* Address */}
        <div className="flex items-start gap-3">
          <span className="font-semibold text-gray-700 w-28">
            Address:
          </span>
          <p className="text-gray-700 leading-relaxed">
            #999/9, 2nd Floor,<br />
            SSMB Plaza,<br />
            5th A Cross,<br />
            Horamavu Service Road,<br />
            Kalyan Nagar Post,<br />
            Bangalore – 560043
          </p>
        </div>

      </div>
    </div>
  );
};

export default ContactUs;
